<template>
  <v-card class="elevation-8">
    <v-card-title primary-title class="greyk lighten-4k">
      <span style="font-weight:bold">Admin. Accounts</span>
      <v-spacer></v-spacer>
      <v-btn icon color="primary" @click="showD=!showD" class="elevation-5">
        <v-icon>add</v-icon>
      </v-btn>

      <!-- <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        style="max-width:40%"
      ></v-text-field>-->
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-data-table :headers="admin_headers" :items="admins" class="elevation-0" :search="search">
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.email }}</td>
          <td class="text-xs-center">{{ props.item.phone?props.item.phone:"N/A" }}</td>
          <td
            class="text-xs-center"
          >{{ props.item.status && props.item.status ==1?"Active" : "Inactive" }}</td>

          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editadmin(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deleteadmin(props.item,props.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- add-edit guardian dialog -->
    <m-dlg pers title="Admin" :show="showD">
      <template v-slot:header-actions>
        <v-btn @click="showD=!showD" icon style="cursor:pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>

      <template v-slot:content>
        <v-form ref="form">
          <v-switch
            :true-value="1"
            :false-value="0"
            v-model="admin_model.status"
            label="Account Status"
            v-if="editedIndex>-1"
          ></v-switch>
          <v-text-field label="Name*" v-model="admin_model.name" :rules="validRules.required"/>
          <v-text-field label="Email*" v-model="admin_model.email" :rules="validRules.email" />
          <v-text-field label="Phone*" v-model="admin_model.phone" :rules="validRules.required" />
          <v-text-field
            label="Password*"
            v-model="admin_model.password"
            min="8"
            :append-icon="e1 ? 'visibility' : 'visibility_off'"
            @click:append="() => (e1 = !e1)"
            :type="e1 ? 'password' : 'text'"
            counter
          />
          <v-text-field
            label="Confirm Password*"
            v-model="conf_pwd"
            min="8"
            :append-icon="e1 ? 'visibility' : 'visibility_off'"
            @click:append="() => (e1 = !e1)"
            :type="e1 ? 'password' : 'text'"
            counter
          />
        </v-form>
      </template>

      <template v-slot:footer-actions>
        <v-btn style="cursor:pointer" color="success" @click="saveadmin()" :loading="loading">save</v-btn>
        <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
      </template>
    </m-dlg>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../Modal";
export default {
  name: "adminaccts-view",
  layout: "admin",
  components: {
    "m-dlg": Modal
  },
  data() {
    return {
      showD: false,
      search: "",
      conf_pwd: "",
      e1: true,
      editedIndex:-1,
      admin_model: {
        name: "",
        email: "",
        phone: "",
        password: "",
        roles: ["administrator"],
        status: 1
      },

      admin_modelcp: {
        name: "",
        email: "",
        phone: "",
        password: "",
        roles: ["administrator"],
        status: 1
      },

      admin_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },

        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        {
          text: "Email",
          align: "center",
          sortable: false,
          value: "email"
        },
        {
          text: "Phone",
          align: "center",
          sortable: false,
          value: "phone"
        },
        {
          text: "Acct. Status",
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          text: "Actions",
          align: "center",
          sortable: true,
          value: "action"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("admins/getAll");
    //console.log("adminsooooo",admins)
  },
  computed: {
    ...mapGetters({
      admins: "admins/ADMINS",
      aerrors: "admins/ADMIN_ERROR",
      loading: "admins/ADMIN_LOADING"
    })
  },
  methods: {
    addadmin() {
      this.$store.dispatch("admins/add", this.admin_model);

      if (this.aerrors==null) {
         this.admin_model = this.admin_modelcp;
        this.editedIndex = -1
        this.conf_pwd = ''
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Admin. Account created successfully",
                title: "Admin Account",
                modal: false
            })
      }else{
        this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry admin account could not be created.",
                title: "Admin Account",
                modal: false
            })
      }


    },
    deleteadmin(admin, index) {
      if (confirm("Are you sure you want to delete this admin?")) {

        //let admidx = this.admins.indexOf(admin);

        this.$store.dispatch("admins/delete", { admin, index });

        if(this.aerrors==null){
          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Admin. Account deleted successfully",
                title: "Admin Account",
                modal: false
            })
        }else{
          this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry admin account could not be deleted.",
                title: "Admin Account",
                modal: false
            })
        }
      }
    },

    editadmin(admin) {
      this.editedIndex = this.admins.indexOf(admin);
      admin.roles = ["administrator"];
      this.admin_model = Object.assign({}, admin);

      this.showD = true;
    },
    updateadmin(user, index) {

      //console.log(user)
      this.$store.dispatch("admins/update", { index, user });

      if (this.aerrors==null) {
        this.showD = false;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Admin. Account updated successfully",
                title: "Admin Account",
                modal: false
            })
      }else{
        this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "sorry, admin account could not be updated.",
                title: "Admin Account",
                modal: false
            })
      }
    },
    saveadmin() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing admin info or saving admin info
      if (this.editedIndex > -1) {
        this.updateadmin(this.admin_model, this.editedIndex);
      } else {
        this.addadmin();
      }
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.admin_model = this.admin_modelcp;
        this.editedIndex = -1
         this.conf_pwd = "";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/adminAccounts.vue